import { Divider, Typography } from "@mui/material";

export function OrgDashboardLabel() {
  return (
    <>
      <Divider orientation="vertical" flexItem sx={{ mx: "16px", my: 2.5 }} />
      <Typography
        sx={{
          fontSize: 18,
          fontWeight: 700,
          color: "#707070",
          whiteSpace: "nowrap",
        }}
      >
        ダッシュボード
      </Typography>
    </>
  );
}
